
import ShoppingCartItems    from '../components/shopping-cart/ShoppingCartItems'
import ShoppingCartSummary  from '../components/shopping-cart/ShoppingCartSummary'
import ShoppingCartCheckout from '../components/shopping-cart/ShoppingCartCheckout'

export default {
  components: {
    ShoppingCartItems,
    ShoppingCartSummary,
    ShoppingCartCheckout
  },
  props: {
    showSummary: {
      type: Boolean,
      default: true
    }
  }
}
